<template>
  <div>
    <el-tabs type="border-card" class="fullHeight">
      <el-tab-pane class="paddingBody bodyHeader" :label="$t('Inicio')">
        <h2 class="txt-bienvenida">Bienvenido {{username}}</h2>
        <p class="font-gray">
          Esta es su tabla de responsabilidades, en ella podrá visualizar la cantidad de Inventarios que tiene asignado por área y por rol
          <br />en la plataforma Inventario de Riesgos HSE Online.
        </p>
        <br />
        <div
          v-loading="loading"
          element-loading-text="Cargando información..."
          element-loading-background="rgba(255, 255, 255"
        >
          <el-form label-position="top" :inline="true" onsubmit="return false;">
            <el-form-item label="Seleccione Faena">
              <el-select
                @change="getRoles"
                class="widthFaena"
                v-model="faena_selected"
                placeholder="Seleccione una Faena"
              >
                <el-option
                  v-for="item in $store.getters.roles"
                  :key="item._id"
                  :label="getFaena(item.faena_id)"
                  :value="item.faena_id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Seleccione tipo de usuario" v-if="data_roles">
              <el-select
                class="widthFaena"
                v-model="type_user"
                placeholder="Seleccione tipo de usuario"
              >
                <el-option
                  v-for="(item, i) in data_roles.type"
                  :key="i"
                  :label="roles[item]"
                  :value="item"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <br />
          <br />
          <!-- TABLA CONTRATISTA -->
          <table v-if="type_user === 'contratista' && data_roles">
            <tr>
              <td></td>
              <td class="cell header-table" :colspan="data_roles.all_roles.contratista.length">Roles</td>
            </tr>
            <tr>
              <td class="cell sub-header-table">Empresas</td>
              <td
                class="cell sub-header-table"
                v-for="(item, i) in data_roles.all_roles.contratista"
                :key="i"
              >{{reviewerRoles[item]}}</td>
            </tr>
            <tr v-for="(empresa, i) in data_roles.empresas" :key="i">
              <td class="cell">{{empresa.nombre}}</td>
              <td
                @click="setData(empresa._id, rol)"
                class="cell"
                v-if="validar(rol, empresa._id)"
                :class="{ selectionCell: validar(rol, empresa._id),cellOrange: validar(rol, empresa._id) }"
                v-for="(rol, i) in data_roles.all_roles.contratista"
                :key="i"
              >
                <center>
                  <i style="font-size: 20px;" class="el-icon-check"></i>
                </center>
              </td>
              <td v-else class="cell cellGray centrar">
                <i style="font-size: 20px;" class="el-icon-close"></i>
              </td>
            </tr>
          </table>
          <!-- TABLA PROPIOS -->
          <table v-if="type_user === 'propio' && data_roles">
            <tr>
              <td></td>
              <td class="cell header-table" :colspan="data_roles.all_roles.propio.length">Roles</td>
            </tr>
            <tr>
              <td class="cell sub-header-table">Áreas</td>
              <td
                class="cell sub-header-table"
                v-for="(item, i) in data_roles.all_roles.propio"
                :key="i"
              >{{reviewerRoles[item]}}</td>
            </tr>
            <tr v-for="(area, i) in data_roles.areas" :key="i">
              <td class="cell">{{area.nombre}}</td>
              <td
                @click="setData(area._id, rol)"
                class="cell"
                :class="{ selectionCell: validar(rol, area._id),cellOrange: validar(rol, area._id), cellGray: !validar(rol, area._id) }"
                v-for="(rol, i) in data_roles.all_roles.propio"
                :key="i"
              >
                <center>
                  <i style="font-size: 20px;" v-if="validar(rol, area._id)" class="el-icon-check"></i>
                  <i style="font-size: 20px;" v-if="!validar(rol, area._id)" class="el-icon-close"></i>
                </center>
              </td>
            </tr>
          </table>
          <!-- TABLA SUPERADMIN -->
          <table v-if="type_user === 'superadmin' && data_roles">
            <tr>
              <td></td>
              <td class="cell header-table" :colspan="data_roles.all_roles.propio.length">Roles</td>
            </tr>
            <tr>
              <td class="cell sub-header-table">Faena</td>
              <td class="cell sub-header-table">Administrador del sistema</td>
            </tr>
            <tr>
              <td class="cell">{{getFaena(faena_selected)}}</td>
              <td @click="setData(null, 'admin')" class="cell selectionCell cellOrange">
                <center>
                  <i style="font-size: 20px;" class="el-icon-check"></i>
                </center>
              </td>
            </tr>
          </table>
          <br />
          <p class="font-gray font-small">
            <b>(*)</b> Para continuar debes hacer click en la celda correspondiente al Área y Rol que necesites utilizar.
            <br />
            <b>(*)</b> Los números que aparecen en la tabla corresponde al total de contratos por rol y área asignada.
            <br />
          </p>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "SelectRoles",
  data() {
    return {
      roles: {
        propio: "Usuario Propio",
        contratista: "Usuario Contratista",
        superadmin: "Administrador de Plataforma"
      },
      faena_selected: "",
      type_user: "",
      data_roles: null,
      reviewerRoles: {
        health: "Especialista de Salud",
        safety: "Especialista de Seguridad",
        environment: "Especialista de Medioambiente",
        contractor_coordinator: "Coordinador Contratista",
        coordinator: "Coordinador",
        contractor_hse: "HSE Contratista",
        contract_owner: "Dueño de Contrato",
        administrator: "Administrador de Contrato",
        hse: "HSE",
        owner: "Dueño de Contrato",
        risk: "Especialista de Riesgo",
        manager: "Gerente de Área",
        super: "Superintendente de Área",
        general_manager: "Gerente General"
      },
      loading: false
    };
  },
  computed: {
    username() {
      return `${this.$store.getters.user.nombre} ${this.$store.getters.user.apellido}`;
    },
    faenas() {
      return this.roles.map(r => r.faena_id);
    }
  },
  async created() {
    this.$store.dispatch("setTitle", this.$t("Seleccion de Rol"));
    this.$store.dispatch(
      "setSubTitle",
      this.$t("Inventario de riesgos HSE online")
    );
    if (!this.$store.getters.latest_state) {
      this.faena_selected = this.$store.getters.roles[0]["faena_id"];
      this.getRoles(this.faena_selected);
    } else {
      this.faena_selected = this.$store.getters.latest_state.faena_selected;
      await this.getRoles(this.faena_selected, true);
      this.type_user = this.$store.getters.latest_state.type_user;
    }
    await this.$store.dispatch("getFaenas");
  },
  methods: {
    validar(rol, id) {
      if (this.type_user === "contratista") {
        if (
          this.data_roles["empresas"][id] &&
          this.data_roles["empresas"][id]["roles"].includes(rol)
        ) {
          return true;
        } else {
          return false;
        }
      }
      if (this.type_user === "propio") {
        if (
          this.data_roles["areas"][id] &&
          this.data_roles["areas"][id]["roles"].includes(rol)
        ) {
          return true;
        } else {
          return false;
        }
      }
    },
    getRoles(faena, clear_type_user) {
      var self = this;
      this.loading = true;
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`
        }
      };
      axios
        .get(
          `/inventarios/getRoles/${this.$store.getters.user._id}/${faena}`,
          config
        )
        .then(function(response) {
          self.data_roles = response.data;
          if (clear_type_user !== true) {
            self.type_user = "";
          }
          self.loading = false;
        })
        .catch(function(error) {
          // handle error
          self.loading = false;
          console.log(error);
        });
    },
    getFaena(faena_id) {
      var faena = this.$store.getters.faenas.find(x => x._id === faena_id);
      if (faena && faena.nombre) {
        return faena.nombre;
      }
    },
    async setData(id, role) {
      const newRole = {
        faena_id: this.faena_selected
      };
      // Empresa
      if (this.type_user === "contratista") {
        newRole.empresa_id = id;
      }
      if (this.type_user === "propio") {
        newRole.area_id = id;
      }
      if (this.type_user === "superadmin") {
        newRole.admin = true;
      }
      // Role
      newRole.role = role;
      //ultimo estado
      let latest_state = {
        faena_selected: this.faena_selected,
        type_user: this.type_user
      };
      // reset datos de otros roles
      await this.$store.dispatch("resetEmpresasFaena");
      await this.$store.dispatch("resetAreas");
      await this.$store.dispatch("resetContract");
      await this.$store.dispatch("resetUserContractByRole");
      await this.$store.dispatch("latestState", latest_state);
      await this.$store.dispatch("setRole", newRole);
      await this.$store.dispatch("setAllTareasPendientes", null);
      if (this.$route.name === "SelectRoles") {
        this.$router.push({ name: "dashboardPersonal" });
      } else {
        this.$router.push({ name: "homePage" });
      }
    }
  }
};
</script>

<style scoped>
.txt-bienvenida {
  font-size: 30px;
  margin-bottom: 0px;
}
.font-gray {
  color: gray;
}
.widthFaena {
  width: 400px;
}
.margin-left-form {
  margin-left: 50px;
}
.centrar {
  text-align: center;
}
.cellGray {
  background-color: white;
}
.cellOrange {
  background-color: #07758D;
  color: white;
}
.header-table {
  font-size: 17px !important;
  color: white;
  background-color: #7f7f7f;
  font-weight: bold;
  text-align: center;
}

.sub-header-table {
  color: white;
  background-color: #7f7f7f;
  font-weight: bold;
  text-align: center;
}

table {
  border-collapse: collapse;
  overflow-x: scroll;
}

thead,
tbody {
  display: block;
}

tbody {
  overflow: auto;
  max-height: 500px;
}

.cell {
  min-width: 210px;
  height: 15px;
  overflow: hidden;
  padding: 7px;
  border: 1px solid rgb(197, 197, 197);
  font-size: 15px;
}

.selectionCell:hover {
  background-color: #07758D;
  cursor: pointer;
}

.widthTd {
  width: 560px;
}

.bodyHeader {
  min-height: 300px;
}

.font-small {
  font-size: 15px;
}
</style>
